export const SITE = {
  name: "Wecare Best Health LLC",
  short: "Wecare Best Health",
  tagline: "Compassionate psychiatric care for children, teens & adults",
  phone: "(312) 473-3714",
  phoneRaw: "+13124733714",
  ext: "Ext. 100",
  fax: "(312) 473-3715",
  email: "info@wecarebesthealth.com",
  address: "2259 W Taylor ST, Chicago, IL 60612",
  state: "Illinois",
  patientPortal: "https://valant.io/prospectivepatient/WecareBestHealth",
  calendly: "https://calendly.com/wecarebesthealth-info/60min",
  website: "www.wecarebesthealth.com",
  provider: {
    name: "Evaresta Charles",
    credentials: "PMHNP-BC, FPA",
    title: "Psychiatric Mental Health Nurse Practitioner",
    yearsExperience: "10+",
  },
  hours: "Mon–Fri · 9:00 AM – 5:00 PM",
};

export const SERVICES = [
  {
    id: "evaluations",
    title: "Comprehensive Psychiatric Evaluations",
    short: "Psychiatric Evaluations",
    description: "Thorough assessments for accurate diagnosis and care.",
    image: "/images/psychiatric-evaluation.jpg",
    icon: "ClipboardCheck",
    tint: { bg: "10 90% 94%", fg: "10 78% 48%" },
  },
  {
    id: "medication",
    title: "Medication Management",
    short: "Medication Management",
    description: "Evidence-based prescribing with close monitoring.",
    image: "/images/medication-management.jpg",
    icon: "Pill",
    tint: { bg: "192 80% 92%", fg: "192 82% 32%" },
  },
  {
    id: "adhd",
    title: "ADHD Evaluations & Care",
    short: "ADHD Care",
    description: "Support for attention, focus, and emotional regulation.",
    image: "/images/adhd-care.jpg",
    icon: "Brain",
    tint: { bg: "38 95% 90%", fg: "30 90% 42%" },
  },
  {
    id: "anxiety",
    title: "Mood & Anxiety Treatment",
    short: "Anxiety & Depression",
    description: "Personalized care for depression, anxiety, and bipolar disorder.",
    image: "/images/anxiety-depression.jpg",
    icon: "HeartPulse",
    tint: { bg: "340 85% 94%", fg: "340 70% 48%" },
  },
  {
    id: "family",
    title: "Family Support",
    short: "Family Support",
    description: "Guidance for parents and caregivers.",
    image: "/images/family-support.jpg",
    icon: "Users",
    tint: { bg: "215 85% 94%", fg: "215 75% 42%" },
  },
  {
    id: "followup",
    title: "Long-Term Follow-Up",
    short: "Follow-Up Care",
    description: "Ongoing care that tracks progress and adjusts treatment.",
    image: "/images/behavioral-therapy.jpg",
    icon: "CalendarHeart",
    tint: { bg: "165 70% 90%", fg: "165 70% 30%" },
  },
];

export const SPECIALTIES = [
  "ADHD (Children & Adults)",
  "Depression",
  "Anxiety Disorders",
  "Bipolar Disorder",
  "DMDD (Disruptive Mood Dysregulation Disorder)",
  "Panic Attacks",
];

export const INSURANCE = [
  { name: "Aetna", logo: "/images/insurance/aetna.svg" },
  { name: "Blue Cross Blue Shield", logo: "/images/insurance/bcbs.svg" },
  { name: "Cigna", logo: "/images/insurance/cigna.svg" },
  { name: "Medicaid", logo: "/images/insurance/medicaid.svg" },
  { name: "Medicare", logo: "/images/insurance/medicare.svg" },
  { name: "Optum", logo: "/images/insurance/optum.svg" },
  { name: "Oscar", logo: "/images/insurance/oscar.svg" },
  { name: "UnitedHealthcare", logo: "/images/insurance/uhc.svg" },
];
